/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 10:47:50
 * @LastEditors: 陈小英 13880788935@163.com
 * @LastEditTime: 2024-04-23 10:08:45
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\tableLogic.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      //  const find = this.platformList.find(
      //    (item) =>
      //      String(item.project) === String(data?.businessLines?.project) &&
      //      String(item.staff_style) === String(data?.businessLines?.staff_style) &&
      //      String(item.type) === String(data?.businessLines?.type)
      //  )
      const lineId = data.businessLines.map((item) => this.getOrg(item, 'id'))
      this.waitItem = { ...data, line_id: lineId }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      cancelText: '取消',
      okText: '确认',
      async onOk() {
        const res = await api.ipAddressWhiteDelete({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      },
    })
  },
}
